<template>
  <div>
    <div>
      <div class="c-card-body">
        <!-- pakai kolom aksi bawaan (jangan set :disableAction) -->
        <datatable
          ref="datatable"
          module="leave-request"
          :title="title"
          :url="url"
          :columns="columns"
          :on-click-create="onClickCreate"
          :on-click-update="onClickUpdate"
          :on-click-delete="onClickDelete"
          :action-width="180"
        >
          <!-- Sisipkan “penanda” di awal sel aksi -->
          <template v-slot:item.action="{ item }">
            <!-- (opsional) tombol VIEW milikmu sendiri; boleh dihapus bila tak perlu -->
            <!--
            <v-btn
              small rounded depressed color="success" dark class="mr-2"
              @click="onClickView(item)"
            >VIEW</v-btn>
            -->
            <span
              v-if="item?.status === 'verified' && !hasVerification"
              class="action-hide-guard"
            />
          </template>
        </datatable>
      </div>
    </div>

    <form-action ref="form" module="leave-request" :success="formSuccess" />
    <delete-dialog
      ref="delete"
      url="leave-request"
      :success="deleteSuccess"
    />
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Datatable from "@/view/component/Datatable.vue";
import DeleteDialog from "@/view/component/DeleteDialog.vue";
import FormAction from "./Form";

export default {
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Manajemen Member", route: "" },
      { title: "Cuti Member" }
    ]);
  },
  data() {
    return {
      title: "Cuti Member",
      url: "leave-request/data",
      columns: [
        { value: "id" },
        { text: "Member", value: "member_name", sortable: true, searchable: true },
        {
          text: "Tanggal Mulai",
          value: "start_date",
          sortable: true,
          searchable: true,
          formatter: v => (v ? this.$moment(v).format("DD/MM/YYYY") : "")
        },
        {
          text: "Tanggal Selesai",
          value: "end_date",
          sortable: true,
          searchable: true,
          formatter: v => (v ? this.$moment(v).format("DD/MM/YYYY") : "")
        },
        { text: "Status", value: "status", sortable: true, searchable: true },
        { text: "Deskripsi", value: "description", sortable: true, searchable: true }
      ]
    };
  },
  computed: {
    hasVerification() {
      return this.$store.getters.hasPermission("leave-request", "verification");
    }
  },
  methods: {
    onClickCreate() { this.$refs.form.open(); },
    onClickUpdate(item) { this.$refs.form.open(item.id); },
    onClickDelete(item) {
      if (item?.status === "verified" && !this.hasVerification) {
        this.$swal.fire({
          icon: "info",
          title: "Tidak Diizinkan",
          text: "Data yang sudah diverifikasi tidak dapat diubah/dihapus oleh akun Anda.",
          showConfirmButton: true
        });
        return;
      }
      this.$refs.delete.open(item.id);
    },
    formSuccess() { this.$refs.datatable.getData(); },
    deleteSuccess() { this.$refs.datatable.getData(); }
  },
  components: { Datatable, DeleteDialog, FormAction }
};
</script>

<style scoped>
/* Sembunyikan semua konten aksi bawaan (menu/tombol) setelah “penanda” */
::v-deep td .action-hide-guard ~ * {
  display: none !important;
}
</style>
